import { ComponentType } from 'react';
import { NodeProps } from 'reactflow';
import { AddNote } from 'assets/js/pages/engage/workflows/actions/AddNote';
import { Branch } from 'assets/js/pages/engage/workflows/actions/Branch';
import { BranchCondition } from 'assets/js/pages/engage/workflows/actions/BranchCondition';
import { ChooseAction } from 'assets/js/pages/engage/workflows/actions/ChooseAction';
import { CreateTask } from 'assets/js/pages/engage/workflows/actions/CreateTask';
import { Delay } from 'assets/js/pages/engage/workflows/actions/Delay';
import { SendEmail } from 'assets/js/pages/engage/workflows/actions/SendEmail';
import { SendSms } from 'assets/js/pages/engage/workflows/actions/SendSms';
import { SetCustomField } from 'assets/js/pages/engage/workflows/actions/SetCustomField';
import { TagContact } from 'assets/js/pages/engage/workflows/actions/TagContact';
import { LeafEnd } from 'assets/js/pages/engage/workflows/components/LeafEnd';
import { AbandonedDonationFormTrigger } from 'assets/js/pages/engage/workflows/triggers/AbandonedDonationForm';
import { AttendedEventTrigger } from 'assets/js/pages/engage/workflows/triggers/AttendedEvent';
import { BecameRecurringDonorTrigger } from 'assets/js/pages/engage/workflows/triggers/BecameRecurringDonor';
import { CanceledRecurringPlanTrigger } from 'assets/js/pages/engage/workflows/triggers/CanceledRecurringPlan';
import { DidNotWinAuctionTrigger } from 'assets/js/pages/engage/workflows/triggers/DidNotWinAuction';
import { DonationMadeTrigger } from 'assets/js/pages/engage/workflows/triggers/DonationMade';
import { FirstTimeDonationTrigger } from 'assets/js/pages/engage/workflows/triggers/FirstTimeDonation';
import { IssuedTicketTrigger } from 'assets/js/pages/engage/workflows/triggers/IssuedTicket';
import { LastGiftMadeTrigger } from 'assets/js/pages/engage/workflows/triggers/LastGiftMade';
import { RecurringPlanAnniversaryTrigger } from 'assets/js/pages/engage/workflows/triggers/RecurringPlanAnniversary';
import { RegisteredForAuctionTrigger } from 'assets/js/pages/engage/workflows/triggers/RegisteredForAuction';
import { SupporterBirthdayTrigger } from 'assets/js/pages/engage/workflows/triggers/SupporterBirthday';
import { TagTrigger } from 'assets/js/pages/engage/workflows/triggers/Tag';
import { TeamMemberMilestoneTrigger } from 'assets/js/pages/engage/workflows/triggers/TeamMemberMilestone';
import { TeamMemberRegisteredTrigger } from 'assets/js/pages/engage/workflows/triggers/TeamMemberRegisteredTrigger';
import { TotalContributionsTrigger } from 'assets/js/pages/engage/workflows/triggers/TotalContributions';
import { WidgetSubscribedTrigger } from 'assets/js/pages/engage/workflows/triggers/WidgetSubscribed';
import {
    WorkflowActionTypeEnum,
    WorkflowTriggerTypeEnum,
    WorkflowUtilityNodeTypeEnum,
} from 'constants/workflows';

const nodeTypes: {
    [key in
        | WorkflowTriggerTypeEnum
        | WorkflowActionTypeEnum
        | WorkflowUtilityNodeTypeEnum]?: ComponentType<NodeProps>;
} = {
    // triggers
    [WorkflowTriggerTypeEnum.ABANDONED_DONATION_FORM]: AbandonedDonationFormTrigger,
    [WorkflowTriggerTypeEnum.ATTENDED_EVENT]: AttendedEventTrigger,
    [WorkflowTriggerTypeEnum.PLAN_CREATED]: BecameRecurringDonorTrigger,
    [WorkflowTriggerTypeEnum.PLAN_CANCELED]: CanceledRecurringPlanTrigger,
    [WorkflowTriggerTypeEnum.DID_NOT_WIN_AUCTION]: DidNotWinAuctionTrigger,
    [WorkflowTriggerTypeEnum.DONATION_CREATED]: DonationMadeTrigger,
    [WorkflowTriggerTypeEnum.CONTACT_FIRST_DONATION]: FirstTimeDonationTrigger,
    [WorkflowTriggerTypeEnum.CONTACT_LAST_DONATION]: LastGiftMadeTrigger,
    [WorkflowTriggerTypeEnum.TICKET_CREATED]: IssuedTicketTrigger,
    [WorkflowTriggerTypeEnum.PLAN_ANNIVERSARY]: RecurringPlanAnniversaryTrigger,
    [WorkflowTriggerTypeEnum.CONTACT_BIRTHDAY]: SupporterBirthdayTrigger,
    [WorkflowTriggerTypeEnum.CONTACT_TAGGED]: TagTrigger,
    [WorkflowTriggerTypeEnum.TEAM_MEMBER_MILESTONE]: TeamMemberMilestoneTrigger,
    [WorkflowTriggerTypeEnum.TEAM_MEMBER_REGISTERED]: TeamMemberRegisteredTrigger,
    [WorkflowTriggerTypeEnum.CONTACT_TOTAL_CONTRIBUTIONS]: TotalContributionsTrigger,
    [WorkflowTriggerTypeEnum.WIDGET_SUBSCRIBED]: WidgetSubscribedTrigger,
    [WorkflowTriggerTypeEnum.REGISTERED_FOR_AUCTION]: RegisteredForAuctionTrigger,

    // utility
    [WorkflowUtilityNodeTypeEnum.CHOOSE_ACTION]: ChooseAction,
    [WorkflowUtilityNodeTypeEnum.DELAY]: Delay,
    [WorkflowUtilityNodeTypeEnum.BRANCH_CONDITION]: BranchCondition,
    [WorkflowUtilityNodeTypeEnum.LEAF_END]: LeafEnd,

    // actions
    [WorkflowActionTypeEnum.SEND_EMAIL]: SendEmail,
    [WorkflowActionTypeEnum.SEND_SMS]: SendSms,
    [WorkflowActionTypeEnum.TASK_CREATE]: CreateTask,
    [WorkflowActionTypeEnum.CONTACT_TAG]: TagContact,
    [WorkflowActionTypeEnum.ADD_NOTE]: AddNote,
    [WorkflowActionTypeEnum.SET_CUSTOM_FIELD]: SetCustomField,
    [WorkflowUtilityNodeTypeEnum.BRANCH]: Branch,
};

export { nodeTypes };
